import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  style: {"min-width":"400px","width":"40vw","margin":"auto","margin-top":"100px"},
  class: "border-box"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = {
  key: 1,
  type: "button",
  class: "btn btn-primary btn-lg btn-block",
  disabled: ""
}
const _hoisted_5 = { key: 1 }

import { ref, onMounted } from 'vue'
    import ValidationError from '@common/Components/ValidationError.vue'
    import { useRequestResetPasswordCommandV1 } from '@Organizations/Users/commands-vue-composables'

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RequestResetPasswordPage',
  setup(__props) {

    const email = ref('')

    const {
        invokeRequestResetPasswordCommandV1,
        invokingRequestResetPasswordCommandV1,
        succeedRequestResetPasswordCommandV1,
        validationErrors
    } = useRequestResetPasswordCommandV1(email)

    onMounted(() =>
    {
        document.title = 'Request reset password'
    })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!_unref(succeedRequestResetPasswordCommandV1))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", null, [
              _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "fg-color-blue" }, "Reset password request", -1 /* CACHED */)),
              _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_3, [
                _cache[2] || (_cache[2] = _createElementVNode("label", { for: "Email" }, "Email:", -1 /* CACHED */)),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                  type: "email",
                  class: "form-control"
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, email.value]
                ]),
                _createVNode(ValidationError, {
                  context: "Email",
                  errors: _unref(validationErrors)
                }, null, 8 /* PROPS */, ["errors"])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("br", null, null, -1 /* CACHED */)),
              (!_unref(invokingRequestResetPasswordCommandV1))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(invokeRequestResetPasswordCommandV1) && _unref(invokeRequestResetPasswordCommandV1)(...args))),
                    type: "button",
                    class: "btn btn-primary btn-lg btn-block"
                  }, "Request"))
                : (_openBlock(), _createElementBlock("button", _hoisted_4, "Requesting..."))
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1 /* CACHED */)),
            _cache[7] || (_cache[7] = _createElementVNode("span", null, [
              _createTextVNode(" Already have an account? "),
              _createElementVNode("a", { href: "/#/signin" }, "Sign-in")
            ], -1 /* CACHED */))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("h1", null, "Your request was sent", -1 /* CACHED */),
            _createElementVNode("h4", null, " If you have an active account in TransparentChoice then you will get an email with reset password link valid 24h. Please use this link to set a new password. ", -1 /* CACHED */)
          ]))]))
    ])
  ]))
}
}

})